import { create } from 'zustand'

type StateType = {
  isLoading: boolean
}

type ActionType = {
  setLoading: (isLoading: StateType['isLoading']) => void
}

export const useLoading = create<StateType & ActionType>(set => ({
  isLoading: false,
  setLoading: (isLoading: StateType['isLoading']) => set({ isLoading }),
}))
